/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { ToolbarComponentCommonProps } from '..';
import { Toggle } from '@g17eco/molecules/toggle';

interface DelegationViewToggleProps extends ToolbarComponentCommonProps {
  handleCheckbox: (status: boolean) => void;
  delegationView: boolean;
}

export const DelegationViewToggle = (props: DelegationViewToggleProps) => {
  const { handleCheckbox, delegationView } = props;

  return (
    <Toggle
      className={{ form: 'd-flex align-items-center pl-0 mb-0 justify-content-end', label: 'text-md ms-1' }}
      checked={delegationView}
      onChange={() => handleCheckbox(!delegationView)}
      label='Delegation view'
    />
  );
}
